import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  headingTitle: {
    id: 'course-authoring.score-board.headingTitle',
    defaultMessage: 'Score board',
  },
  nameAndDate: {
    id: 'course-authoring.score-board.nameAndDate.label',
    defaultMessage: 'Name & Date of Submission',
  },
  firstTerm: {
    id: 'course-authoring.score-board.firstTerm.label',
    defaultMessage: 'First Term 1',
  },
  secondTerm: {
    id: 'course-authoring.score-board.secondTerm.label',
    defaultMessage: 'First Term 2',
  },
  thirdTerm: {
    id: 'course-authoring.score-board.thirdTerm.label',
    defaultMessage: 'Mid Term 1',
  },
  fourTerm: {
    id: 'course-authoring.score-board.fourTerm.label',
    defaultMessage: 'Mid Term 2',
  },
  finalTerm: {
    id: 'course-authoring.score-board.finalTerm.label',
    defaultMessage: 'Final Term 1',
  },
  result: {
    id: 'course-authoring.score-board.result.label',
    defaultMessage: 'Result',
  },
  score: {
    id: 'course-authoring.score-board.score.label',
    defaultMessage: 'Score',
  },
  emptyPlaceHolderTitle: {
    id: 'course-authoring.score-board.empty-placeholder.title',
    defaultMessage: 'No scores to display yet.',
  },
  emptyPlaceHolderDesc: {
    id: 'course-authoring.score-board.empty-placeholder.desc',
    defaultMessage: 'Once students start submitting, their scores will be visible here.',
  },
  inviteButtonText: {
    id: 'course-authoring.score-board.inviteButtonText',
    defaultMessage: 'Add',
  },
  fullNameHeading: {
    id: 'gradebook.GradesView.table.headings.fullName',
    defaultMessage: 'Full Name',
    description: 'Gradebook table full name column header',
  },
  emailHeading: {
    id: 'gradebook.GradesView.table.headings.email',
    defaultMessage: 'Email',
    description: 'Gradebook table email column header',
  },
  totalGradeHeading: {
    id: 'gradebook.GradesView.table.headings.totalGrade',
    defaultMessage: 'Total Grade (%)',
    description: 'Gradebook table total grade column header',
  },
  usernameHeading: {
    id: 'gradebook.GradesView.table.headings.username',
    defaultMessage: 'Username',
    description: 'Gradebook table username column header',
  },
  studentKeyLabel: {
    id: 'gradebook.GradesView.table.labels.studentKey',
    defaultMessage: 'Student Key',
    description: 'Gradebook table Student Key label',
  },
  usernameLabel: {
    id: 'gradebook.GradesView.table.labels.username',
    defaultMessage: 'Username',
    description: 'Gradebook table username label',
  },
  totalGradePercentage: {
    id: 'gradebook.GradesView.table.totalGradePercentage',
    defaultMessage: 'Total Grade values are always displayed as a percentage',
    description: 'Gradebook table message that total grades are displayed in percent format',
  },
  noResultsFound: {
    id: 'gradebook.GradesView.table.noResultsFound',
    defaultMessage: 'No results found',
    description: 'Gradebook table message when no learner results were found',
  },
});

export default messages;
